import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "../axiosBaseQuery";
import { IPredectivePayload } from "../../interface/IHome";

export interface GetPopupPayload {
  selectedLableValue:string,
  selectedLable: string,
  selectedInd?: number | null,
  isStoreProcData: boolean
}


export const homeApi = createApi({
  reducerPath: 'homeApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getGBPAlerts: builder.mutation({
      query: (payload: IPredectivePayload) => ({
        url: '/getGBPAlerts',
        method: 'POST',
        data: payload,
      }),
    }),
    getInventoryAlerts: builder.mutation({
      query: (payload: IPredectivePayload) => ({
        url: '/getInventoryAlerts',
        method: 'POST',
        data: payload,
      }),
    }),
    getGBPFilters: builder.mutation({
      query: (payload: IPredectivePayload) => ({
        url: '/getGBPFilters',
        method: 'POST',
        data: payload,
      }),
    }),
    getDropdownPopup: builder.mutation({
      query: (payload: GetPopupPayload) => ({
        url: '/getDropdownPopup',
        method: 'POST',
        data: payload,
      }),
    }),
  }),
});

export const {
  useGetGBPAlertsMutation,
  useGetInventoryAlertsMutation,
  useGetGBPFiltersMutation,
  useGetDropdownPopupMutation
} = homeApi;
